import { render, staticRenderFns } from "./BoutiqueAdd.vue?vue&type=template&id=da44c544&scoped=true"
import script from "./BoutiqueAdd.vue?vue&type=script&lang=js"
export * from "./BoutiqueAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da44c544",
  null
  
)

export default component.exports